/* eslint-disable jsx-a11y/anchor-is-valid */

import React from 'react';
import styled from 'styled-components';

import Link from '@ntuctech/devex-tangram/Link';
import Typography from '@ntuctech/devex-tangram/Typography';

import PageContent from '../theme/PageContent';
import PageHeader from '../theme/PageHeader';
import SignUpForm from './SignUpForm';
import PageFooter from '../theme/PageFooter';

import { usePageContext } from '../PageContextProvider';
import { PAGE_CONTEXT } from '../../constants/app-constants';
import GA from '../../services/google-analytics-tags';

const PageContentSC = styled(PageContent)``;

export default () => {
  const { setPageContext } = usePageContext();

  const handleLogin = () => {
    GA.track('Sign-up', 'Navigate to sign-in');
    setPageContext(PAGE_CONTEXT.LOGIN);
  };

  return (
    <>
      <PageContentSC>
        <PageHeader header="Sign up for an account" />
        <SignUpForm />
      </PageContentSC>
      <PageFooter>
        <Typography variant="body3" className="SSOPage__page-note">
          Already have an account?{' '}
          <Link onClick={handleLogin} href="#" data-testid="logInPageLink">
            Log in
          </Link>
        </Typography>
      </PageFooter>
    </>
  );
};
